import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase, ref, onValue } from 'firebase/database';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID // Optional: for Analytics
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const dbRealTime = getDatabase(app);
const db = getFirestore(app);

// Initialize Analytics (lazy initialization to avoid circular dependencies)
let analytics = null;
let analyticsInitialized = false;

export const initializeAnalytics = () => {
  if (analyticsInitialized || typeof window === 'undefined') {
    return analytics;
  }
  
  analyticsInitialized = true;
  
  if (firebaseConfig.measurementId) {
    isSupported().then(supported => {
      if (supported) {
        analytics = getAnalytics(app);
        console.log('✅ Firebase Analytics initialized');
      }
    }).catch(err => {
      console.warn('Analytics initialization failed:', err);
      analytics = null;
    });
  } else {
    console.log('ℹ️ Analytics disabled (measurementId not configured)');
  }
  
  return analytics;
};

// Debug logging
console.log('Firebase initialized');
console.log('Database URL:', process.env.REACT_APP_FIREBASE_DATABASE_URL);
console.log('Database ref:', dbRealTime);

// Connection test (will be called after app initialization)
export const initializeFirebaseConnection = () => {
  const connectedRef = ref(dbRealTime, '.info/connected');
  onValue(connectedRef, (snap) => {
    if (snap.val() === true) {
      console.log('✅ Connected to Firebase');
    } else {
      console.log('❌ Disconnected from Firebase');
    }
  });
};

// Getter for analytics that initializes on first access
export const getAnalyticsInstance = () => {
  if (!analyticsInitialized) {
    initializeAnalytics();
  }
  return analytics;
};

export { auth, dbRealTime, db, analytics };
